import { render } from "./AppDownloader.vue?vue&type=template&id=5c832164"
import script from "./AppDownloader.vue?vue&type=script&lang=js"
export * from "./AppDownloader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__